<template>
  <div class="page-home">
    <Slider :data="content" />   
  </div>
</template>

<script>

import Slider from "./shared/Slider.vue";

export default {
  name: "Home", //this is the name of the component
  components: {
    "Slider": Slider,
  },

  data() { 
    return {
      content: {
        heading: 'Angebote', 
        slides: [{ className: 'slider-cranio', htmlContent: `<h2><div class='font-normal'>Ganzheitliches Wohlbefinden</div>
          <a href='/energiebalance' class='info-link'>Craniosacrale Energiebalance für Mensch und Tier</a></h2><ul class='list-hyphen small-font margin-tb'>
          <li>mobil im Raum Niederösterreich und Wien unterwegs</li><li>Haus- bzw. Stallbesuche</li></ul>`
          }, 
          { className: 'slider-trauerreden', htmlContent: `<h2><a href='/trauerreden' class='info-link'>Ihr individueller Abschied liebevoll begleitet</a>
          <div class='margin-b' >Nachrufe, Trauerreden, Grabreden</div></h2>`
          }
        ] 
      }
    }
  },
 metaInfo() {
        return { 
            title: "Katharina Herda - Craniosacrale Energiebalance und Trauerreden",
            meta: [
              { name: 'description', content: 'Ganzheitliche Behandlung von Mensch, Pferd und Hund durch sanften Berührungen zur Wiederherstellung des natürlichen Gleichgewichts im Körper' },
              { property: 'og:title', content: "Katharina Herda - Craniosacrale Energiebalance und Trauerreden"},
              { property: 'og:description', content: 'Ganzheitliche Behandlung von Mensch, Pferd und Hund durch sanften Berührungen zur Wiederherstellung des natürlichen Gleichgewichts im Körper'},
              { property: 'og:image', content: 'src/img/assets/ueber-mich/kathi.jpg'},
              { property: 'og:url', content: 'www.herda.at'}
            ]
        }
}

};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Home.vue